import React, { useState } from 'react';
import { Row, Label, Input, Col } from "reactstrap"


const DBRadioButtonNew = ({ rowClass, labelText, types, OnChange, Disabled, value, labelShow = true, textAlign }) => {
  return (
    <Row className={rowClass}>
      {labelShow ? <Col className="col-md-3">

        <Label
          htmlFor="example-text-input"
          className={`col-md-12 col-form-label-sm`}
        >
          {labelText}
        </Label>
      </Col> : null}

      {types.map(opt => (
        <Col style={{ textAlign: textAlign == "" ? 'center' : textAlign, columnWidth: 'auto' }}>
          <Row>
            <Col >
              <input
                style={{ height: '15px', width: '15px' }}
                className="form-check-input"
                type="radio"
                name={opt.name != "" ? opt.name : "exampleRadios"}
                id="defaultCheck2"
                value={opt.value}
                onChange={OnChange}
                disabled={Disabled}
                checked={value == opt.value ? true : false}
              />
              <label
                className="form-check-label-sm"
                htmlFor="defaultCheck2"
                style={{ marginLeft: "5px" }}
                // onClick={OnChange}

              >
                {opt.label}
              </label>
            </Col>
          </Row>
        </Col>
      ))}

    </Row>
  );
}

export default DBRadioButtonNew;